import styled from "styled-components";

export const InicioContainer = styled.header`
    height: 100vh;
    background-image: url("/img/Trajes-web2.jpg");
    background-size: cover;
    background-position: center right;
    background-repeat: no-repeat;
    position: relative;
    background-color: #fff7d9;
    display: flex;
    padding: 0 8%;
    align-items: center;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        background: linear-gradient(
            to right,
            rgba(0,0,0,0.75),
            rgba(0,0,0,0.4),
            rgba(0,0,0,0.2)
        );
        z-index: 1;
    }

    @media (max-width: 1024px) {
        background-position: center;
    }

    @media (max-width: 768px) {
        height: 90vh;
        background-position: center top;
        background-image: url("/img/Trajes-webc.jpg");
        padding: 0 5%;
    }
`;

export const Overlay = styled.div `
    position: absolute;
    inset: 0;
    background: rgba(255,255,255,0.15);
    backdrop-filter: blur(1px);
    pointer-events: ${({ collapsed }) => (collapsed ? "auto" : "none")};
`;

export const Content = styled.div`
    position: relative;
    text-shadow: 0 10px 30px rgba(0,0,0,0.5);
    z-index: 2;
    max-width: 600px;
    color: #111;

    @media (max-width: 768px) {
        text-align: center;
        margin: 0 auto;
    }
`;

export const Title = styled.h1`
    font-size: 3.8rem;
    margin-bottom: 15px;
    line-height: 1.2;
    letter-spacing: 6px;
    color: #ffffff;
    font-weight: 200;
    text-transform: uppercase;

    @media (max-width: 768px) {
        font-size: 2.2rem;
    }
`;

export const Subtitle = styled.p`
    font-size: 1rem;
    color: rgba(199, 199, 199, 0.7);
    letter-spacing: 0.5px;
    margin-bottom: 30px;
    line-height: 1.6;
    max-width: 400px;

    @media (max-width: 768px) {
        font-size: 0.95rem;
    }
`;

export const Button = styled.div`
    display: flex;
    gap: 20px;
    margin-top: 10px;
    flex-wrap: wrap;
`;

export const ButtonPrimary = styled.button `
    padding: 12px 28px;
    border-radius: 2px;
    
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(0,0,0,0.6);
    backdrop-filter: blur(6px);
    
    color: #fff;
    cursor: pointer;
    letter-spacing: 1.5px;
    font-size: 0.85rem;
    transition: 0.3s;
    text-transform: uppercase;
    font-weight: 500;

    &:hover {
        background: #ffffff;
        color: #000;
    }
`;

export const ButtonSecondary = styled.button`
    padding: 12px 28px;
    border: 1px solid #ffffff;
    background: transparent;
    text-transform: uppercase;
    font-weight: 500;
    color: #ffffff;
    cursor: pointer;
    font-size: 0.85rem;
    letter-spacing: 1.5px;
    transition: 0.3s;

    &:hover {
        background: #ffffff;
        color: #000000;
    }
`;

export const ToggleButton = styled.button`
    position: absolute;
    top: 25px;
    right: 30px;
    z-index: 6;

    background: transparent;
    border: 1px solid ${({ collapsed }) => (collapsed ? "#ffffff" : "#ffffff")};
    color: ${({ collapsed }) => (collapsed ? "#ffffff" : "#ffffff")};

    font-size: 1.5rem;
    padding: 8px 12px;
    cursor: pointer;
    transition: 0.3s;

    &:hover {
        background: ${({ collapsed}) => (collapsed ? "#bbbbbb" : "#bbbbbb")};
        color: ${({ collapsed }) => (collapsed ? "#000000" : "#000000")};
    }
`;

export const NavMenu = styled.nav`
    position: fixed;
    top: 0;
    right: 0;

    height: 100vh;
    width: 300px;

    box-sizing: border-box;

    background: rgba(17, 17, 17, 0.95);
    backdrop-filter: blur(10px);
    border-left: 1px solid rgba(255, 255, 255, 0.1);

    display: flex;
    flex-direction: column;

    padding: 100px 30px;
    gap: 25px;

    overflow-y: auto;
    overflow-x: hidden;

    -webkit-overflow-scrolling: touch;

    transform: ${({ collapsed }) =>
        collapsed ? "translateX(0)" : "translateX(100%)"};
    
    pointer-events: ${({ collapsed }) => 
        collapsed ? "auto" : "none"};

    transition: transform 0.4s ease;
    z-index: 5;

    @media (max-width: 768px) {
        width: 100%;
        align-items: stretch;
        justify-content: flex-start;
        padding: 100px 20px 40px;
    }
`;

export const NavItem = styled.a`
    color: #e5e4de;
    font-size: 28px;
    letter-spacing: 2px;
    cursor: pointer;

    padding: 12px 0;
    border-radius: 4px;

    transition: all 0.3s ease;

    width: 100%;
    text-align: center;

    background: ${({ active }) => 
        active ? "rgba(255, 255, 255, 0.08)" : "transparent"};

    @media (max-width: 768px) {
        font-size: 34px;
    }

    a {
        text-decoration: none;
        color: inherit;
    }

    &:hover {
        opacity: 0.6;
        transform: translateX(8px);
        transition: all 0.3s ease;
    }
`;

export const Section = styled.section`
    padding: 100px 8%;
    text-align: center;
    background: ${({ bg }) => bg || "#f5f4f0"};
    color: ${({ color }) => color || "#111111"};
    background-color: #b5b09b;

    @media (max-width: 768px) {
        padding: 60px 5%;
    }

    h2 {
        font-size: 30px;
        margin-bottom: 40px;
        letter-spacing: 2px;
    }
`;

export const ProductGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 40px;

    @media (max-width: 768px) {
        gap: 20px;
    }
`;

export const ProductCard = styled.div`
    position: relative;

    background: transparent;
    border-radius: 8px;
    overflow: hidden;
    text-align: center;
    padding: 0;
    box-shadow: none;
    cursor: pointer;

    opacity: 0;
    transform: translateY(30px);

    transition: all 0.6s ease;
    transition-delay: ${({ delay }) => delay || "0s"};

    &.visible {
        opacity: 1;
        transform: translateY(0);
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: none;
    }

    &:hover img {
        transform: scale(1.03);
        filter: brightness(0.72);

        transition: all 0.6s ease;
    }

    &:hover .hover-text{
        opacity: 1;
        transform: translate(-50%, -50%);
    }

    img {
        width: 100%;
        height: 350px;
        object-fit: cover;

        transition: all 0.6s ease;
    }

    h3 {
        font-size: 1.1rem;
        margin-bottom: 8px;
        color: #111111;
    }

    p {
        margin-top: 12px;
        font-size: 20px;
        letter-spacing: 1.5px;
        text-transform: uppercase;
        color: #e5e4de;
    }

    .hover-text {
        position: absolute;

        top: 40%;
        left: 50%;

        transform: translateX(-50%) translateY(15px);

        opacity: 0;

        color: #fff;
        font-size: 14px;
        letter-spacing: 3px;
        text-transform: uppercase;

        background: rgba(0,0,0,0.55);

        padding: 12px 22px;
        border-radius: 999px;

        backdrop-filter: blur(6px);

        transition: all 0.35s ease;

        z-index: 2;
    }
`;

export const RelatedCard = styled.div`
    max-width: 700px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    cursor: pointer;

    img {
        width: 100%;
        aspect-ratio: 5 / 4;
        object-fit: cover;
        transition: transform 0.6s ease;
    }

    &:hover img {
        transform: scale(1.03);
    }

    p {
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);

        cursor: pointer;
        
        box-shadow: 0 8px 20px rgba(0,0,0,0.25);
        opacity: 1;
        z-index: 2;

        padding: 10px 22px;

        background: rgba(0,0,0,0.7);
        backdrop-filter: blur(6px);

        color: #fff;
        font-size: 0.8rem;
        letter-spacing: 2px;
        text-transform: uppercase;

        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 2px;

        transition: all 0.3s ease;
    }

    &:hover p,
    &:active p {
        background: #fff;
        color: #000;
        transform: translateX(-50%) translateY(-3px) scale(1.05);
        box-shadow: 0 12px 25px rgba(0,0,0,0.35);
        opacity: 1;
    }
    
`;

export const CTASection = styled(Section)`
    background: #111111;
    color: #fff;
    padding: 120px 8%;
    text-align: center;

    button {
        margin-top: 20px;
    }

    h2 {
        font-size: 2.5rem;
        font-weight: 300;
        letter-spacing: 2px;
        max-width: 600px;
        margin: 0 auto;
    }
`;

export const Footer = styled.footer`
    background: #111111;
    color: #999999;
    padding: 50px 8%;
    text-align: center;
    font-size: 0.8rem;
    letter-spacing: 1px;

    a {
        color: #e5e4de;
        margin: 0 10px;
        text-decoration: none;
        transition: 0.3s;
        opacity: 0.7;

        &:hover {
            opacity: 1;
        }
    }

    @media (max-width: 768px) {
        padding: 40px 5%;
    }
`;

export const DarkSection = styled.section`
    background: #111;
    color: #e5e4de;
    padding: 100px 8%;
    text-align: center;

    h2 {
        font-size: 2rem;
        letter-spacing: 2px;
        margin-bottom: 20px;
    }

    p {
        max-width: 500px;
        margin: 0 auto;
        color: #aaa;
    }
`;

export const BackToTop = styled.button`
    position: fixed;
    bottom: 30px;
    right: 30px;
    z-index: 100;

    background: linear-gradient(135deg, #1a1a1a, #000);
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 50%;

    width: 50px;
    height: 50px;

    font-size: 1.2rem;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;

    box-shadow: 0 10px 25px rgba(0,0,0,0.3);

    animation: fadeInUp 0.5s ease;

    transition: all 0.3s ease;

    &:hover {
        background: #fff;
        transform: translateY(-4px) scale(1.08);
        color: #000;
    }

    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(30px) scale(0.95);
        }
        to {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
    }
`;

export const MapContainer = styled.div`
    width: 100%;
    aspect-ratio: 1/1;
    overflow: hidden;
    border-radius: 20px;

    box-shadow: 0 20px 40px rgba(0,0,0,0.2);
    transition: 0.3s;

    &:hover {
        transform: scale(1.03);
    } 
`;

export const MapFrame = styled.iframe `
    width: 100%;
    height: 100%;
    border: 0;

    pointer-events: none;
`;

export const WhatsAppButon = styled.button `
    position: fixed;
    bottom: 90px;
    right: 30px;
    z-index: 100;

    width: 55px;
    height: 55px;
    border-radius: 50%;

    background: linear-gradient(135deg, #1a1a1a, #000);
    color: #fff;
    
    border: 1px solid rgba(255, 255, 255, 0.15);

    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 1.4rem;
    cursor: pointer;

    box-shadow: 0 10px 25px rgba(0,0,0,0.3);

    animation: fadeIn 0.8s forwards, pulse 2.5s infinite;

    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-4px) scale(1.08);
        background: #25D366;
        color: #000;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes pulse {
        0% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.4);
        }

        70% {
            box-shadow: 0 0 0 12px rgba(37, 211, 102, 0);
        }

        100% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
        }
    }
`;

export const FloatingButtons = styled.div`
    position: fixed;
    bottom: 30px;
    right: 2px;
    z-index: 100;

    display: flex;
    flex-direction: column;
    gap: 15px;

    animation: fadeInGroup 0.8s ease forwards;

    @keyframes fadeInGroup {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;